import { Feather } from '@expo/vector-icons';
import { useFormikContext } from 'formik';
import React from 'react';

import styled from 'styled-components/native';
import Colors from '../../constants/Colors';
import { Caption } from '../Typography';

const StyledContainer = styled.View<{ disabled?: boolean }>`
  flex-direction: row;
  opacity: ${p => (p.disabled ? 0.6 : 1)};
  align-items: center;
`;

const StyledTextContainer = styled.View`
  flex-shrink: 1;
`;

const StyledBox = styled.TouchableOpacity<{
  touched?: boolean;
  dark?: boolean;
}>`
  align-self: flex-start;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  /* border: 1px solid
    ${p =>
    p.touched ? Colors.formInputBorderHighlight : Colors.formInputBorder}; */
  background-color: ${p =>
    p.touched ? Colors.checkboxTouched : Colors.checkbox};
  ${p => (p.dark ? 'border-color: #000' : '')}
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`;

const ErrorText = styled.Text`
  font-family: 'DMSans-Medium';
  font-size: 12px;
  line-height: 18px;
  color: ${Colors.error};
`;

export interface FormCheckboxProps {
  name: string;
  accessibilityLabel?: string;
  testID?: string;
  dark?: boolean;
  label?: string | JSX.Element;
  disabled?: boolean;
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  name,
  accessibilityLabel,
  testID,
  label,
  dark,
  disabled
}) => {
  const { setFieldValue, handleBlur, touched, errors, values } =
    useFormikContext<any>();
  const error = touched[name] && errors[name];
  return (
    <StyledContainer disabled={disabled}>
      <StyledBox
        disabled={disabled}
        dark={dark}
        touched={values[name] || false}
        activeOpacity={0.9}
        accessibilityLabel={accessibilityLabel}
        testID={testID}
        onPress={() => setFieldValue(name, !values[name])}
      >
        {values[name] && <Feather name='check' size={14} color='#FFF' />}
      </StyledBox>
      <StyledTextContainer>
        {typeof label === 'string' ? (
          <Caption color={dark ? 'dark' : undefined}>{label}</Caption>
        ) : (
          label
        )}
        {error && <ErrorText>{error as any}</ErrorText>}
      </StyledTextContainer>
    </StyledContainer>
  );
};

export default FormCheckbox;
